import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface TeamBulkItem {
  name: string;
  display_name: string;
  division: number;
  is_active: boolean;
}

export const useCreateTeamsBulk = () => {
  const { authHeader } = useAuth();

  return useMutation((teams: TeamBulkItem[]) => {
    return axios.post(`${env.verifyServiceUrl}common/team/bulk/`, teams, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
